import React from "react";
import { Waveform } from "@uiball/loaders";
import { Box } from "@mui/material";

const Loading = ({ size = 40, color = "#04aeea" }) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999
      }}
    >
      <Waveform size={size} color={color} />
    </Box>
  );
};

export default Loading;
